import { render, staticRenderFns } from "./bread-crumb.vue?vue&type=template&id=adb9470c&scoped=true&"
import script from "./bread-crumb.vue?vue&type=script&lang=js&"
export * from "./bread-crumb.vue?vue&type=script&lang=js&"
import style0 from "./bread-crumb.vue?vue&type=style&index=0&id=adb9470c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adb9470c",
  null
  
)

export default component.exports